module.exports = __webpack_public_path__ + "media/images/salespartner/bg-mv_sp-c1bfcb9de83121e115b07745948232e7.png";